import { serialize } from 'object-to-formdata';
import requestOptions from './requestOptions';
import { Dispatch, SetStateAction } from 'react';

type Props = {
    zapierId: string;
    data: any; //eslint-disable-line
    setSubmitted: Dispatch<SetStateAction<boolean>>;
};

const submitToZapier = async ({ zapierId, data, setSubmitted }: Props): Promise<void> => {
    const formData = serialize(data);

    const options = requestOptions(formData);

    try {
        const response = await fetch(`https://hooks.zapier.com/hooks/catch/2377900/${zapierId}/`, options);
        const result = await response.text();
        const respObj = JSON.parse(result);

        if (respObj.status === 'success') {
            setSubmitted(true);
        }
    } catch (error) {
        console.log('error', error);
    }
};

export default submitToZapier;
